import { BlueBannerStyles, YellowBannerStyles, RedBannerStyles, PurpleBannerStyles, OrangeBannerStyles, GreenBannerStyles, DarkGrayBannerStyles } from "./styles.js";
function getBannerStyles(color) {
  switch (color) {
    case "blue":
      return BlueBannerStyles;
    case "dark-grey":
      return DarkGrayBannerStyles;
    case "green":
      return GreenBannerStyles;
    case "orange":
      return OrangeBannerStyles;
    case "purple":
      return PurpleBannerStyles;
    case "red":
      return RedBannerStyles;
    case "yellow":
      return YellowBannerStyles;
    default:
      return BlueBannerStyles;
  }
}
export {
  getBannerStyles
};
